import { render, staticRenderFns } from "./ReceivedRequestWorkflow.vue?vue&type=template&id=1535a480&"
import script from "./ReceivedRequestWorkflow.vue?vue&type=script&lang=js&"
export * from "./ReceivedRequestWorkflow.vue?vue&type=script&lang=js&"
import style0 from "./ReceivedRequestWorkflow.vue?vue&type=style&index=0&id=1535a480&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports